import { Link } from 'react-router-dom';
import { Button, Card } from '@novaquantis/design-system';
import BrandMark from '../components/BrandMark';

interface AccessDeniedPageProps {
  featureName?: string;
  message?: string;
}

const AccessDeniedPage = ({
  featureName,
  message = 'This feature has been disabled by an administrator.',
}: AccessDeniedPageProps) => (
  <div className="flex flex-1 items-center justify-center px-6 py-8">
    <Card className="flex w-full max-w-[420px] flex-col items-center gap-3 text-center">
      <BrandMark wordmarkSize={24} />
      <h1 className="m-0 font-display text-xl font-bold text-foreground">
        {featureName ? `${featureName} unavailable` : 'Access denied'}
      </h1>
      <p className="m-0 text-sm leading-normal text-muted-foreground">{message}</p>
      <Link to="/" className="no-underline">
        <Button variant="glow">Go home</Button>
      </Link>
    </Card>
  </div>
);

export default AccessDeniedPage;
